import { z } from 'zod';

import { makeEndpoint } from '../common';

export const MemberProfileEndpoint = makeEndpoint({
  method: 'GET',
  url: () => 'hyatt/member',
  requestSchema: z.object({
    accessToken: z.string().nonempty('Access Token is required'),
  }),
  responseSchema: z.object({
    loyaltyId: z.string().nonempty(),
    memberSince: z.string().nonempty(),
    tierCode: z.string().nonempty(),
    tierExpiration: z.string().nonempty(),
    firstName: z.string().nonempty(),
    points: z.string().nonempty(),
  }),
});
